import React from "react";
import { 
  Button, 
  Card, 
  Text,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import MetaData from "#root/layouts/MetaData";
import { ROUTES } from "#root/routes/constants";

const ServiceUnavailable: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <MetaData
        title="503 Service Unavailable"
        description="Sorry, the service is temporarily unavailable."
      />
      <Card appearance="filled-alternative">
        <Text size={900} weight="bold" align="center">503</Text>
        <Text size={500} align="center">Sorry, the service is temporarily unavailable.</Text>
        <Button appearance="primary" onClick={() => navigate(ROUTES.ROOT)} style={{ display: 'block', margin: '0 auto' }}>
          Back Home
        </Button>
      </Card>
    </>
  );
};

export default ServiceUnavailable;
